import { Injectable } from '@angular/core';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class PingService {
  localStorageService: any;
  universalService: any;
  public static pingcall:any;
  http: any;
  public static singleInstance: any = null;


  public static getInstance(globalService): PingService {
    if (this.singleInstance == null) {
      this.singleInstance = new PingService(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  constructor(public globalService:GlobalService) {
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.http = this.globalService.getHttpClientRef();
   }


  startInterval(){
    var pingUrl =  ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["ping"];//
    this.ping(pingUrl);
  }


  clearInterval(){
    clearInterval(PingService.pingcall);
    PingService.pingcall = undefined;
  }

  public ping(pingUrl: string){ 
		var userData = this.localStorageService.getUserData(true);
		let expiresIn =  (userData != undefined) ? userData["authToken"]["expiresIn"] : '';
    if(expiresIn.length == 0){
      this.clearInterval();
      return
    }
    let pingTime = (expiresIn/2) * 1000;
    // let pingTime = 10000; //added this for testing
		PingService.pingcall = setInterval(() =>{
      this.http.get(pingUrl).subscribe(
        (suc) => {
          
        },
        (error) => {
          console.log("token could not be extended",error);
        },
      );
		}, pingTime)  
	}


  restartPingIntervalWhenSwitchingPreview(){
    this.clearInterval();
    this.startInterval();
  }
}
